import { dateTimeMinuteFormatter, hourMinuteFormatter } from '@dreryk/react-common';
import { AutoLayout, ClockIcon, IconFillColor, IconWrapper } from '@dreryk/react-components';

type VisitDateTimeProps = {
   readonly plannedBeginDate: Date;
   readonly plannedEndDate: Date;
};

export const VisitDateTime = (props: VisitDateTimeProps): JSX.Element => {
   return (
      <AutoLayout as={'div'} $spacing={4} $alignement={'center'} $horizontalResizing={'hug'}>
         <IconWrapper testId={'clock'} fillColor={IconFillColor.BACKGROUND}>
            <ClockIcon />
         </IconWrapper>
         <span>
            {dateTimeMinuteFormatter(props.plannedBeginDate)}
            {props.plannedBeginDate !== props.plannedEndDate && `-${hourMinuteFormatter(props.plannedEndDate)}`}
         </span>
      </AutoLayout>
   );
};
